import React from "react";
import { MessageWithAvatar } from "../../../../../core/atoms/atoms";

export const TeamInitialMessage: React.FC = () => {
  const messageWithAvatarProps = {
    avatarUrl: "/images/team.jpg",
    avatarName: "Our team",
  }

  return (
    <MessageWithAvatar
      {...messageWithAvatarProps}
    >
      <>
        <h3>One of our team will be in touch within 2 working days to discuss your trip planning further!</h3>
        <p>
          All our local experts have different specialities, so to make sure we introduce you to{` `}
          the best person for you we need a few more details about your trip.
        </p>
        <p>
          If we have your number we&apos;ll give you a call, otherwise we&apos;ll message you here.{` `}
          You&apos;ll get an email notification as well. We&apos;re looking forward to speaking soon!
        </p>
      </>
    </MessageWithAvatar>
  );
}
